<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7501_5323)">
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint0_linear_7501_5323)"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint1_linear_7501_5323)"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint2_linear_7501_5323)"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint3_linear_7501_5323)"
            fill-opacity="0.13"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint4_linear_7501_5323)"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint5_linear_7501_5323)"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint6_radial_7501_5323)"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint7_radial_7501_5323)"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint8_radial_7501_5323)"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint9_linear_7501_5323)"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint10_linear_7501_5323)"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint11_linear_7501_5323)"
            fill-opacity="0.55"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint12_linear_7501_5323)"
            fill-opacity="0.55"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint13_linear_7501_5323)"
      />
      <path d="M18.9554 2.45714C18.9554 2.25574 19.0132 2.08551 18.9036 2.06398C19.0078 2.07061 19.879 1.9884 19.9727 2.09776C20.0959 2.14614 20.0219 2.34283 20.1184 2.43704C20.1212 2.43979 20.124 2.44255 20.1268 2.44534L26.38 8.69861C26.3991 8.71767 26.4173 8.73743 26.4346 8.75781C26.52 8.85816 26.564 8.83626 26.6041 8.96021C26.636 9.05879 26.8651 8.85466 26.8651 8.96021L26.942 9.11378V9.32821C26.942 9.32821 26.9901 9.57904 26.8651 9.57904L20.3926 10.3003C19.3649 10.3003 18.397 9.11893 18.397 8.45619L18.9554 2.45714Z"
            fill="url(#paint14_linear_7501_5323)"
      />
      <path d="M18.9554 2.45714C18.9554 2.25574 19.0132 2.08551 18.9036 2.06398C19.0078 2.07061 19.879 1.9884 19.9727 2.09776C20.0959 2.14614 20.0219 2.34283 20.1184 2.43704C20.1212 2.43979 20.124 2.44255 20.1268 2.44534L26.38 8.69861C26.3991 8.71767 26.4173 8.73743 26.4346 8.75781C26.52 8.85816 26.564 8.83626 26.6041 8.96021C26.636 9.05879 26.8651 8.85466 26.8651 8.96021L26.942 9.11378V9.32821C26.942 9.32821 26.9901 9.57904 26.8651 9.57904L20.3926 10.3003C19.3649 10.3003 18.397 9.11893 18.397 8.45619L18.9554 2.45714Z"
            fill="url(#paint15_linear_7501_5323)"
      />
      <path d="M18.9554 2.45714C18.9554 2.25574 19.0132 2.08551 18.9036 2.06398C19.0078 2.07061 19.879 1.9884 19.9727 2.09776C20.0959 2.14614 20.0219 2.34283 20.1184 2.43704C20.1212 2.43979 20.124 2.44255 20.1268 2.44534L26.38 8.69861C26.3991 8.71767 26.4173 8.73743 26.4346 8.75781C26.52 8.85816 26.564 8.83626 26.6041 8.96021C26.636 9.05879 26.8651 8.85466 26.8651 8.96021L26.942 9.11378V9.32821C26.942 9.32821 26.9901 9.57904 26.8651 9.57904L20.3926 10.3003C19.3649 10.3003 18.397 9.11893 18.397 8.45619L18.9554 2.45714Z"
            fill="url(#paint16_linear_7501_5323)"
      />
      <path d="M20.0391 2.34758C20.0391 2.14618 19.8811 2.06645 19.7715 2.04492C19.8756 2.05156 19.9774 2.07442 20.0732 2.11206C20.1965 2.16045 20.31 2.23328 20.4065 2.32748C20.4093 2.33023 20.4121 2.33299 20.4149 2.33578L26.6681 8.58905C26.6872 8.60812 26.7054 8.62787 26.7227 8.64825C26.8081 8.7486 26.8723 8.86426 26.9124 8.9882C26.9443 9.08678 26.961 9.19061 26.961 9.29616V9.3593C26.961 9.1271 26.793 8.9882 26.6681 8.9882H21.2391C20.5764 8.9882 20.0391 8.45094 20.0391 7.78821V2.34758Z"
            fill="url(#paint17_linear_7501_5323)"
      />
      <path d="M20.0391 2.34758C20.0391 2.14618 19.8811 2.06645 19.7715 2.04492C19.8756 2.05156 19.9774 2.07442 20.0732 2.11206C20.1965 2.16045 20.31 2.23328 20.4065 2.32748C20.4093 2.33023 20.4121 2.33299 20.4149 2.33578L26.6681 8.58905C26.6872 8.60812 26.7054 8.62787 26.7227 8.64825C26.8081 8.7486 26.8723 8.86426 26.9124 8.9882C26.9443 9.08678 26.961 9.19061 26.961 9.29616V9.3593C26.961 9.1271 26.793 8.9882 26.6681 8.9882H21.2391C20.5764 8.9882 20.0391 8.45094 20.0391 7.78821V2.34758Z"
            fill="url(#paint18_linear_7501_5323)"
      />
      <path d="M20.0391 2.34758C20.0391 2.14618 19.8811 2.06645 19.7715 2.04492C19.8756 2.05156 19.9774 2.07442 20.0732 2.11206C20.1965 2.16045 20.31 2.23328 20.4065 2.32748C20.4093 2.33023 20.4121 2.33299 20.4149 2.33578L26.6681 8.58905C26.6872 8.60812 26.7054 8.62787 26.7227 8.64825C26.8081 8.7486 26.8723 8.86426 26.9124 8.9882C26.9443 9.08678 26.961 9.19061 26.961 9.29616V9.3593C26.961 9.1271 26.793 8.9882 26.6681 8.9882H21.2391C20.5764 8.9882 20.0391 8.45094 20.0391 7.78821V2.34758Z"
            fill="url(#paint19_linear_7501_5323)"
      />
      <path d="M20.0391 2.34758C20.0391 2.14618 19.8811 2.06645 19.7715 2.04492C19.8756 2.05156 19.9774 2.07442 20.0732 2.11206C20.1965 2.16045 20.31 2.23328 20.4065 2.32748C20.4093 2.33023 20.4121 2.33299 20.4149 2.33578L26.6681 8.58905C26.6872 8.60812 26.7054 8.62787 26.7227 8.64825C26.8081 8.7486 26.8723 8.86426 26.9124 8.9882C26.9443 9.08678 26.961 9.19061 26.961 9.29616V9.3593C26.961 9.1271 26.793 8.9882 26.6681 8.9882H21.2391C20.5764 8.9882 20.0391 8.45094 20.0391 7.78821V2.34758Z"
            fill="url(#paint20_linear_7501_5323)"
      />
      <path d="M20.0391 2.34758C20.0391 2.14618 19.8811 2.06645 19.7715 2.04492C19.8756 2.05156 19.9774 2.07442 20.0732 2.11206C20.1965 2.16045 20.31 2.23328 20.4065 2.32748C20.4093 2.33023 20.4121 2.33299 20.4149 2.33578L26.6681 8.58905C26.6872 8.60812 26.7054 8.62787 26.7227 8.64825C26.8081 8.7486 26.8723 8.86426 26.9124 8.9882C26.9443 9.08678 26.961 9.19061 26.961 9.29616V9.3593C26.961 9.1271 26.793 8.9882 26.6681 8.9882H21.2391C20.5764 8.9882 20.0391 8.45094 20.0391 7.78821V2.34758Z"
            fill="url(#paint21_radial_7501_5323)"
      />
      <path d="M20.0391 2.34758C20.0391 2.14618 19.8811 2.06645 19.7715 2.04492C19.8756 2.05156 19.9774 2.07442 20.0732 2.11206C20.1965 2.16045 20.31 2.23328 20.4065 2.32748C20.4093 2.33023 20.4121 2.33299 20.4149 2.33578L26.6681 8.58905C26.6872 8.60812 26.7054 8.62787 26.7227 8.64825C26.8081 8.7486 26.8723 8.86426 26.9124 8.9882C26.9443 9.08678 26.961 9.19061 26.961 9.29616V9.3593C26.961 9.1271 26.793 8.9882 26.6681 8.9882H21.2391C20.5764 8.9882 20.0391 8.45094 20.0391 7.78821V2.34758Z"
            fill="url(#paint22_radial_7501_5323)"
      />
      <path d="M20.0391 2.34758C20.0391 2.14618 19.8811 2.06645 19.7715 2.04492C19.8756 2.05156 19.9774 2.07442 20.0732 2.11206C20.1965 2.16045 20.31 2.23328 20.4065 2.32748C20.4093 2.33023 20.4121 2.33299 20.4149 2.33578L26.6681 8.58905C26.6872 8.60812 26.7054 8.62787 26.7227 8.64825C26.8081 8.7486 26.8723 8.86426 26.9124 8.9882C26.9443 9.08678 26.961 9.19061 26.961 9.29616V9.3593C26.961 9.1271 26.793 8.9882 26.6681 8.9882H21.2391C20.5764 8.9882 20.0391 8.45094 20.0391 7.78821V2.34758Z"
            fill="url(#paint23_radial_7501_5323)"
      />
      <path d="M20.0391 2.34758C20.0391 2.14618 19.8811 2.06645 19.7715 2.04492C19.8756 2.05156 19.9774 2.07442 20.0732 2.11206C20.1965 2.16045 20.31 2.23328 20.4065 2.32748C20.4093 2.33023 20.4121 2.33299 20.4149 2.33578L26.6681 8.58905C26.6872 8.60812 26.7054 8.62787 26.7227 8.64825C26.8081 8.7486 26.8723 8.86426 26.9124 8.9882C26.9443 9.08678 26.961 9.19061 26.961 9.29616V9.3593C26.961 9.1271 26.793 8.9882 26.6681 8.9882H21.2391C20.5764 8.9882 20.0391 8.45094 20.0391 7.78821V2.34758Z"
            fill="url(#paint24_radial_7501_5323)"
      />
      <path d="M20.0391 2.34758C20.0391 2.14618 19.8811 2.06645 19.7715 2.04492C19.8756 2.05156 19.9774 2.07442 20.0732 2.11206C20.1965 2.16045 20.31 2.23328 20.4065 2.32748C20.4093 2.33023 20.4121 2.33299 20.4149 2.33578L26.6681 8.58905C26.6872 8.60812 26.7054 8.62787 26.7227 8.64825C26.8081 8.7486 26.8723 8.86426 26.9124 8.9882C26.9443 9.08678 26.961 9.19061 26.961 9.29616V9.3593C26.961 9.1271 26.793 8.9882 26.6681 8.9882H21.2391C20.5764 8.9882 20.0391 8.45094 20.0391 7.78821V2.34758Z"
            fill="url(#paint25_radial_7501_5323)"
      />
      <path d="M17.5273 20.9961C17.8013 20.9961 18.0234 21.2182 18.0234 21.4922C18.0234 21.7662 17.8013 21.9883 17.5273 21.9883H9.53516C9.26117 21.9883 9.03906 21.7662 9.03906 21.4922C9.03906 21.2182 9.26117 20.9961 9.53516 20.9961H17.5273ZM22.457 17.9961C22.731 17.9961 22.9531 18.2182 22.9531 18.4922C22.9531 18.7662 22.731 18.9883 22.457 18.9883H9.53516C9.26117 18.9883 9.03906 18.7662 9.03906 18.4922C9.03906 18.2182 9.26117 17.9961 9.53516 17.9961H22.457ZM22.457 14.9961C22.731 14.9961 22.9531 15.2182 22.9531 15.4922C22.9531 15.7662 22.731 15.9883 22.457 15.9883H9.53516C9.26117 15.9883 9.03906 15.7662 9.03906 15.4922C9.03906 15.2182 9.26117 14.9961 9.53516 14.9961H22.457ZM22.457 11.9961C22.731 11.9961 22.9531 12.2182 22.9531 12.4922C22.9531 12.7662 22.731 12.9883 22.457 12.9883H9.53516C9.26117 12.9883 9.03906 12.7662 9.03906 12.4922C9.03906 12.2182 9.26117 11.9961 9.53516 11.9961H22.457Z"
            fill="url(#paint26_linear_7501_5323)"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_7501_5323"
                      x1="16"
                      y1="2.04297"
                      x2="16"
                      y2="29.957"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EBE4F3" />
        <stop offset="1"
              stop-color="#E4DAF0"
        />
      </linearGradient>
      <linearGradient id="paint1_linear_7501_5323"
                      x1="16"
                      y1="2.1698"
                      x2="16"
                      y2="2.40336"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F3F0F6" />
        <stop offset="1"
              stop-color="#F3F0F6"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint2_linear_7501_5323"
                      x1="26.9609"
                      y1="15.308"
                      x2="26.6187"
                      y2="15.308"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F3F0F6" />
        <stop offset="1"
              stop-color="#F3F0F6"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint3_linear_7501_5323"
                      x1="27.1897"
                      y1="15.308"
                      x2="26.7872"
                      y2="15.308"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B9A6CC" />
        <stop offset="1"
              stop-color="#B9A6CC"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_7501_5323"
                      x1="4.22004"
                      y1="15.308"
                      x2="5.22056"
                      y2="15.3099"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B5B0BB" />
        <stop offset="1"
              stop-color="#B5B0BB"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_7501_5323"
                      x1="17.5191"
                      y1="30.4889"
                      x2="17.5191"
                      y2="29.77"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B5B0BB" />
        <stop offset="1"
              stop-color="#B5B0BB"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint6_radial_7501_5323"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(5.62045 30.1415) rotate(-72.992) scale(0.519149 1.6851)"
      >
        <stop stop-color="#B5B0BB" />
        <stop offset="1"
              stop-color="#B5B0BB"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint7_radial_7501_5323"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(5.17657 29.7561) rotate(-60.2552) scale(0.470877 1.52842)"
      >
        <stop stop-color="#B5B0BB" />
        <stop offset="1"
              stop-color="#B5B0BB"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint8_radial_7501_5323"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(5.00136 29.2479) rotate(-38.6597) scale(0.336577 1.0925)"
      >
        <stop stop-color="#B5B0BB" />
        <stop offset="1"
              stop-color="#B5B0BB"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint9_linear_7501_5323"
                      x1="4.58809"
                      y1="28.5747"
                      x2="5.2868"
                      y2="28.5747"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B5B0BB" />
        <stop offset="1"
              stop-color="#B5B0BB"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint10_linear_7501_5323"
                      x1="4.27192"
                      y1="2.31183"
                      x2="5.57713"
                      y2="2.87885"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B5B0BB" />
        <stop offset="1"
              stop-color="#B5B0BB"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint11_linear_7501_5323"
                      x1="4.50255"
                      y1="14.9251"
                      x2="5.51228"
                      y2="14.9251"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B9A6CC" />
        <stop offset="1"
              stop-color="#B9A6CC"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint12_linear_7501_5323"
                      x1="16"
                      y1="29.957"
                      x2="16"
                      y2="29.7195"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B9A6CC" />
        <stop offset="1"
              stop-color="#B9A6CC"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint13_linear_7501_5323"
                      x1="26.4103"
                      y1="29.7849"
                      x2="26.2656"
                      y2="29.5156"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B9A6CC" />
        <stop offset="1"
              stop-color="#B9A6CC"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint14_linear_7501_5323"
                      x1="21.3047"
                      y1="4.93425"
                      x2="19.5882"
                      y2="4.93425"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.72"
              stop-color="#D2C5DE"
        />
        <stop offset="1"
              stop-color="#D2C5DF"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint15_linear_7501_5323"
                      x1="23.7247"
                      y1="11.2271"
                      x2="23.7124"
                      y2="8.96194"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.72"
              stop-color="#E9E1F3"
        />
        <stop offset="1"
              stop-color="#E9E1F3"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint16_linear_7501_5323"
                      x1="20.4841"
                      y1="8.26212"
                      x2="18.7881"
                      y2="10.9197"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E9E1F3"
              stop-opacity="0"
        />
        <stop offset="0.682292"
              stop-color="#E9E1F3"
        />
      </linearGradient>
      <linearGradient id="paint17_linear_7501_5323"
                      x1="20.5391"
                      y1="8.70696"
                      x2="23.1797"
                      y2="6.06633"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D9D3E1" />
        <stop offset="1"
              stop-color="#CCC7D1"
        />
      </linearGradient>
      <linearGradient id="paint18_linear_7501_5323"
                      x1="23.7735"
                      y1="5.55071"
                      x2="23.1329"
                      y2="6.17571"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.119171"
              stop-color="#DBDADC"
        />
        <stop offset="0.577307"
              stop-color="#CBC7D0"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint19_linear_7501_5323"
                      x1="20.0157"
                      y1="4.74829"
                      x2="20.1634"
                      y2="4.74829"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A19CA7" />
        <stop offset="1"
              stop-color="#9D9CA7"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint20_linear_7501_5323"
                      x1="23.3662"
                      y1="9.0351"
                      x2="23.3662"
                      y2="8.83197"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C0ACD5" />
        <stop offset="1"
              stop-color="#C0ACD5"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint21_radial_7501_5323"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.8847 9.09811) rotate(-81.1582) scale(0.369824 2.14157)"
      >
        <stop stop-color="#C0ACD5" />
        <stop offset="1"
              stop-color="#C0ACD5"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint22_radial_7501_5323"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.3244 8.822) rotate(-40.8602) scale(0.341752 1.97901)"
      >
        <stop stop-color="#A19CA7" />
        <stop offset="1"
              stop-color="#A19CA7"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint23_radial_7501_5323"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.034 8.50434) rotate(-24.7752) scale(0.336783 1.95023)"
      >
        <stop stop-color="#A19CA7" />
        <stop offset="1"
              stop-color="#A19CA7"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint24_radial_7501_5323"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.8378 8.15705) rotate(-6.45541) scale(0.422175 2.44472)"
      >
        <stop stop-color="#A19CA7" />
        <stop offset="1"
              stop-color="#A19CA7"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint25_radial_7501_5323"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.4666 8.88586) rotate(-59.8587) scale(0.275483 1.59526)"
      >
        <stop stop-color="#A19CA7" />
        <stop offset="1"
              stop-color="#A19CA7"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint26_linear_7501_5323"
                      x1="9.03906"
                      y1="21.4922"
                      x2="18.0234"
                      y2="21.4922"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9C96A2" />
        <stop offset="1"
              stop-color="#9A95A1"
        />
      </linearGradient>
      <clipPath id="clip0_7501_5323">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
